import { useEffect } from "react";

import { useSalesContext } from "../../../../../sales-context/SalesContext";
import { useCustomerProgram } from "./useCustomerProgram";

export const useAutoSelectSurvey = () => {
    const { partnerConfig } = useSalesContext();
    const programs = partnerConfig.programs;
    const { customerProgram, setCustomerProgram, removeCustomerProgram } = useCustomerProgram();

    useEffect(() => {
        if (programs?.length === 1) {
            setCustomerProgram(programs[0]);
        } else {
            removeCustomerProgram();
        }
    }, [programs, setCustomerProgram, removeCustomerProgram]);

    return { customerProgram };
};
